import React, { useRef, useState } from "react";
import {
  FormControl,
  FormLabel,
  Text,
  Input,
  Box,
  List,
  ListItem,
  useOutsideClick,
} from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import get from "lodash/get";

interface DropdownProps {
  name?: string;
  label?: string;
  control?: any;
  errors?: any;
  options: any[];
  valueKey: string;
  labelKey: string;
  placeholder?: string;
  isRequired?: boolean;
  disable?: boolean;
  bgColor?: string;
  value?: any;
  onChange?: (value: any) => void;
}

export const Dropdown = ({
  name,
  label,
  control,
  errors,
  options,
  valueKey,
  labelKey,
  value,
  onChange,
  placeholder,
  isRequired,
  disable,
  bgColor = "white",
}: DropdownProps) => {
  const [search, setSearch] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  // const error = get(errors, name);
  useOutsideClick({
    ref: rootRef,
    handler: () => setShowOptions(false),
  });

  const parseValue = (val: any) => {
    if (val === "true") return true;
    if (val === "false") return false;
    if (!isNaN(val) && String(val).trim() !== "") return Number(val);
    return val;
  };

  const filteredOptions = options.filter((opt) =>
    String(opt[labelKey]).toLowerCase().includes(search.toLowerCase())
  );


  if (!control) {
    const selectedOption = options.find(
      (opt) => opt[valueKey] === value
    );

    return (
      <FormControl mt={2}>
        <Box ref={rootRef} position="relative">
          <Input
            value={showOptions ? search : selectedOption?.[labelKey] || ""}
            placeholder={placeholder || "Search..."}
            onChange={(e) => {
              setSearch(e.target.value);
              setShowOptions(true);
            }}
            onFocus={() => {
              setSearch("");
              setShowOptions(true);
            }}
            isDisabled={disable}
            bg={bgColor}
          />

          {showOptions && (
            <Box
              mt={2}
              border="1px solid #E2E8F0"
              borderRadius="md"
              bg="white"
              maxH="220px"
              overflowY="auto"
              boxShadow="sm"
              zIndex={10}
              position="absolute"
              width="100%"
            >
              <List>
                {filteredOptions.map((opt, idx) => (
                  <ListItem
                    key={idx}
                    px={4}
                    py={3}
                    cursor="pointer"
                    _hover={{ bg: "#EDF2F7" }}
                    onClick={() => {
                      onChange?.(parseValue(opt[valueKey]));
                      setSearch("");
                      setShowOptions(false);
                    }}
                  >
                    {opt[labelKey]}
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
        </Box>
      </FormControl>
    );
  }
  return (

    <Controller
      name={name!}
      control={control}
      render={({ field }) => {
        const selectedOption = options.find(
          (opt) => opt[valueKey] === field.value
        );
      //  const error = get(errors, name);
        const error = get(errors, name!);

        return (
          <FormControl isInvalid={!!error} mt={2}>
            {label && (
              <FormLabel className='font-poppins text_medium text_md '>
                {label}{" "}
                {isRequired && (
                  <Text as="span" color="red.500">
                    *
                  </Text>
                )}
              </FormLabel>
            )}

            <Box ref={rootRef} position="relative">
              {/* Search / Selected Input */}
              <Input
                value={showOptions ? search : selectedOption?.[labelKey] || ""}
                placeholder={placeholder || `Search...`}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setShowOptions(true);
                }}
                onFocus={() => {
                  setSearch("");
                  setShowOptions(true);
                }}
                isDisabled={disable}
                bg={bgColor}
              />

              {/* Dropdown List */}
              {showOptions && (
                <Box
                  mt={2}
                  border="1px solid #E2E8F0"
                  borderRadius="md"
                  bg="white"
                  maxH="220px"
                  overflowY="auto"
                  boxShadow="sm"
                  zIndex={10}
                  position="absolute"
                  width="100%"
                >
                  <List>
                    {filteredOptions.length > 0 ? (
                      filteredOptions.map((opt, idx) => (
                        <ListItem
                          key={idx}
                          px={4}
                          py={3}
                          cursor="pointer"
                          _hover={{ bg: "#EDF2F7" }}
                          onClick={() => {
                            field.onChange(parseValue(opt[valueKey]));
                            setSearch("");
                            setShowOptions(false);
                          }}
                        >
                          {opt[labelKey]}
                        </ListItem>
                      ))
                    ) : (
                      <ListItem px={4} py={3} color="gray.500">
                        No results found
                      </ListItem>
                    )}
                  </List>
                </Box>
              )}
            </Box>
            {error?.message && (
              <Text color="red.500">
                {error.message}
              </Text>
            )}
            {/* <Text color="red.500" fontSize="sm">
              {errors?.[name]?.message}
            </Text> */}
          </FormControl>
        );
      }}
    />
  );
};